export const productsList = [
  {
    id: "saas-distribusi",
    key: "saas-distribusi",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    icon: "fas fa-truck-loading",
    titleKey: "product1-title",
    descKey: "product1-desc",
  },
  {
    id: "saas-klinik",
    key: "saas-klinik",
    image:
      "https://images.unsplash.com/photo-1516549655669-df6654e435f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    icon: "fas fa-clinic-medical",
    titleKey: "product2-title",
    descKey: "product2-desc",
  },
];
